import script from "./warning-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./warning-dialog.vue?vue&type=script&setup=true&lang=js"

import "./warning-dialog.vue?vue&type=style&index=0&id=4b972f56&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b972f56"]])

export default __exports__